import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TableHeadRoot } from './TableHead.styled';
// Component.
// -----------------------------------------------------------------------------
const TableHead = forwardRef(({ children, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(TableHeadRoot, { ref: ref, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableHead.displayName = 'TableHead';
export default TableHead;
//# sourceMappingURL=TableHead.js.map